import { render, staticRenderFns } from "./ChoiceBlock.vue?vue&type=template&id=1e911032&scoped=true&"
import script from "./ChoiceBlock.vue?vue&type=script&lang=js&"
export * from "./ChoiceBlock.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceBlock.vue?vue&type=style&index=0&id=1e911032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e911032",
  null
  
)

export default component.exports